<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            <div class="panel">
                <b-loading :is-full-page="false" :active.sync="loginsLoading" :can-cancel="true"></b-loading>
                <p class="panel-heading">
                    Inicios de sesion mas recientes.
                </p>
                <div v-for="log in logins" :key="log.id" class="panel-block">
                    <p>
                        {{log.email}} 
                        <span class="tag is-info is-rounded">
                            {{ new Date(log.lastLogin).toLocaleDateString() }}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        lastLogins:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            logins:[],
            loginsLoading:false
        }
    },
    methods:{
        async fetchLogins(){
            this.loginsLoading = true
            this.logins = await getHandler(this.lastLogins, {error:false, success:false})
            this.loginsLoading = false
        }
    },
    created(){
        this.fetchLogins()
    }

}
</script>

<style lang="scss" scoped>
.panel-heading{
    background:hsl(217, 71%, 53%);
    color: #fff;
}
</style>